module.exports = __webpack_public_path__ + "img/UsSuperMillions_Ad1.d51da3d4.png";